/* global fbq */

import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'

export default function DropDown({ elements, onChange, defaultValue, disabled }) {
  const [active, setActive] = useState(defaultValue || elements[0]);
  const [clicked, setClicked] = useState(false);

  //fire a meta CustomizeProduct event when the active state changes if it is one of the following values: 'Grandmaster', 'Master', 'Diamond', 'Platinum', 'Gold', 'Silver', 'Bronze', 'Iron', 'Unranked'

  useEffect(() => {
    onChange(active);
  }, [active, onChange]);

  const pushToDataLayer = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  useEffect(() => {
    if (!clicked) return;
  
    const lastFiredTime = localStorage.getItem('eventFiredTime');
    const currentTime = Date.now();
  
    const cooldown = 10 * 60 * 1000; // 10 minutes
  
    if (!lastFiredTime || currentTime - lastFiredTime >= cooldown) {
      if (elements.includes(active)) {
        const validRanks = [
          'Challenger', 'Grandmaster', 'Master', 'Diamond', 'Platinum', 'Gold',
          'Silver', 'Bronze', 'Iron', 'Unranked'
        ];
  
        if (validRanks.includes(active)) {
          localStorage.setItem('eventFiredTime', currentTime.toString());
          if (typeof fbq !== 'undefined') {
            fbq('track', 'CustomizeProduct');
          } 
          pushToDataLayer({
            event: 'customize_product'
          });
        }
      }
    } else {
      //console.log('Cooldown active, skipping CustomizeProduct event.');
    }
  }, [clicked, active, elements]);
  

  useEffect(() => {
    setActive(defaultValue || elements[0]);
  }, [elements, defaultValue]);

  // When clicked outside of the dropdown, close it
  useEffect(() => {
    const close = () => {
      setClicked(false);
    };
    window.addEventListener('click', close);
    return () => window.removeEventListener('click', close);
  }, []);

  // Prevent the click event on the button from propagating to the window click listener
  const handleButtonClick = (e) => {
    e.stopPropagation();
    setClicked((current) => !current);
  };

  if(elements.includes('Grandmaster')){
    return (
      <div className={`dropdown${clicked ? ' clicked' : ' inactive'} wide`} onClick={handleButtonClick}>
        <FontAwesomeIcon icon={faCaretDown} />
        <button>{active}</button>
        <div className={`dropdown-content${clicked ? ' clicked' : ''} wide`}>
          {elements.map((element) => (
            <a
              key={element}
              className={`dropdown-element${element === active ? ' active' : ' inactive'}${
                disabled && disabled.includes(element) ? ' disabled' : ''
              }`}
              onClick={() => (disabled && disabled.includes(element) ? null : setActive(element))}
            >
              {element}
            </a>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`dropdown${clicked ? ' clicked' : ' inactive'}`} onClick={handleButtonClick}>
      <FontAwesomeIcon icon={faCaretDown} />
      <button>{active}</button>
      <div className={`dropdown-content${clicked ? ' clicked' : ''}`}>
        {elements.map((element) => (
          <a
            key={element}
            className={`dropdown-element${element === active ? ' active' : ' inactive'}${
              disabled && disabled.includes(element) ? ' disabled' : ''
            }`}
            onClick={() => (disabled && disabled.includes(element) ? null : setActive(element))}
          >
            {element}
          </a>
        ))}
      </div>
    </div>
  );
}
